import { Coupons } from "../../services/cellcast.v2.types";

const formatUSD = (val: any) => {
  const data: any = new Intl.NumberFormat('en-US').format(val)
  return data
}

export const showDiscountType = (item: Coupons) => {
  let discountTitle = '--';
  let discountValue = '--';

  switch (item?.discountType) {
    case "percentage":
      discountTitle = "Percentage";
      discountValue = item?.percentageOff ? `${item.percentageOff}%` : '--';
      break;
    case "fixed_price":
      discountTitle = "Flat Rate";
      discountValue = item?.flatRate ? `$${formatUSD(item.flatRate)}` : '--';
      break;
    case "free_credit":
      discountTitle = "Free Credit";
      discountValue = item?.freeCredit ? `${item.freeCredit}` : '--';
      break;
    default:
      discountTitle = item?.discountType || '--';
      discountValue = '--';
  }

  return {
    title: discountTitle,
    value: discountValue,
  }
}